import SunAccent from "@/components/feature/SunAccent";
import { Link } from "react-router-dom";
import { useKonaseemaGuide } from "@/hooks/usePublicGuide";

export default function KonaseemaHero() {
  const { gallery: konaseemaGallery, facts: konaseemaFacts } = useKonaseemaGuide();
  return (
    <section className="relative min-h-[70vh] flex flex-col justify-end overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={konaseemaGallery[0].src}
          width={1920}
          height={1080}
          alt={konaseemaGallery[0].alt}
          title="Konaseema travel guide - backwaters and coconut groves"
          className="w-full h-full object-cover object-top"
          fetchPriority="high"
          decoding="async"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/35 to-black/80"></div>
      </div>

      <div className="relative w-full px-4 md:px-8 pt-28 md:pt-32 pb-12 md:pb-16">
        <nav className="flex items-center gap-2 text-xs md:text-sm text-background-200 mb-6 flex-wrap">
          <Link to="/" className="hover:text-background-50 transition-colors">
            Home
          </Link>
          <i className="ri-arrow-right-s-line"></i>
          <span className="text-background-50">Konaseema</span>
        </nav>

        <div className="flex items-center gap-3 mb-5">
          <SunAccent circleClassName="w-8 h-8" iconClassName="text-base" /><span className="h-px w-10 bg-accent-400"></span>
          <span className="text-xs font-semibold tracking-[0.28em] uppercase text-accent-300">
            Travel Guide
          </span>
        </div>

        <h1 className="font-heading text-4xl md:text-6xl leading-[1.05] text-background-50 font-semibold max-w-3xl">
          Konaseema — Where Our <span className="italic text-accent-300">Journey Begins.</span>
        </h1>
        <p className="mt-6 text-base md:text-lg text-background-100 leading-relaxed max-w-2xl">
          A green delta of coconut groves, paddy fields and winding canals on the Godavari —
          experience the beauty of rural Andhra Pradesh.
        </p>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mt-10 max-w-4xl">
          {konaseemaFacts.map((fact) => (
            <div key={fact.label} className="border-l-2 border-accent-500/70 pl-4">
              <p className="text-[11px] font-semibold uppercase tracking-wider text-accent-300">
                {fact.label}
              </p>
              <p className="text-xs md:text-sm text-background-100 mt-1 leading-snug">
                {fact.value}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}